export default __webpack_public_path__ + "leter-a-inside-a-black-circle.png";